import React, { useState, useEffect, useRef, useCallback } from 'react'
import styled from 'styled-components'
import useActiveWeb3React from 'contexts/Web3Context'
import { Flex, Box, Heading, Link, Text } from '@pancakeswap/uikit'
import { useTranslation } from 'contexts/Localization'
import { Pool } from 'state/types'
import ConnectWalletButton from 'components/ConnectWalletButton'
import useIntersectionObserver from 'hooks/useIntersectionObserver'
import useGetTopFarmsByApr from 'views/Home/hooks/useGetTopFarmsByApr'
import useGetTopPoolsByApr from 'views/Home/hooks/useGetTopPoolsByApr'
import TopFarmPool from './TopFarmPool'
import RowHeading from './RowHeading'
import { CustomButton } from '../CustomButton'

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(1, auto);

  ${({ theme }) => theme.mediaQueries.sm} {
    grid-gap: 16px;
    grid-template-columns: repeat(2, auto);
  }

  ${({ theme }) => theme.mediaQueries.md} {
    grid-gap: 32px;
  }
`

const BunnyWrapper = styled.div`
  width: 100%;
  text-align: right;

  img {
    display: none;
    margin-left: auto;

    ${({ theme }) => theme.mediaQueries.sm} {
      display: block;
      max-width: 280px;
    }

    ${({ theme }) => theme.mediaQueries.md} {
      max-width: 390px;
    }
  }
`

const FarmsPoolsRow = () => {
  const [showFarms, setShowFarms] = useState(false)
  const { t } = useTranslation()
  const { account } = useActiveWeb3React()
  const { observerRef, isIntersecting } = useIntersectionObserver()
  const { topFarms } = useGetTopFarmsByApr(isIntersecting)
  const { topPools } = useGetTopPoolsByApr(isIntersecting)

  const getPoolText = (pool: Pool) => {
    if (pool.isAutoVault) {
      return t('Auto BIRB')
    }

    if (pool.sousId === 0) {
      return t('Manual BIRB')
    }

    return t('Stake %stakingSymbol% - Earn %earningSymbol%', {
      earningSymbol: pool.earningToken.symbol,
      stakingSymbol: pool.stakingToken.symbol,
    })
  }

  return (
    <>
      <Flex
        position="relative"
        flexDirection={['row', null, null, 'row']}
        alignItems={['center', null, null, 'center']}
        justifyContent="center"
      >
        <Flex flex="1" flexDirection="column">
          <Heading scale="xl" color="input" mb="8px">
            {t('Earn BIRB')}
          </Heading>
          <Text mb="24px" color="input" fontSize="21px">
            {t('Earn passive income with crypto.')}
          </Text>
          <Flex>
            <Link mr="16px" href="/pools">
              <CustomButton variant='primary'>{t('Explore')}</CustomButton>
            </Link>
          </Flex>
        </Flex>
        <Flex
          height={['fit-content', null, null, 'fit-content']}
          width={['fit-content', null, null, 'fit-content']}
          flex={[null, null, null, '1']}
          mb={['24px', null, null, '0']}
          position="relative"
        >
          <BunnyWrapper>
            <img src="/images/custom/home-3.png" alt={t('Home 3rd section')} />
          </BunnyWrapper>
        </Flex>
      </Flex>
      <div ref={observerRef}>
        <Flex flexDirection="column" mt={["10px", "10px", "15px", 0]}>
          <Flex mb="8px">
            {/* <RowHeading text={showFarms ? t('Top Farms') : t('Top Pools')} /> */}
            <Text color="input" fontSize="14px">{t('Top Pools')}</Text>
            {/* <IconButton
            variant="text"
            height="100%"
            width="auto"
            onClick={() => {
              // setShowFarms((prev) => !prev)
              // clearInterval(timer.current)
              // startTimer()
            }}
          >
            <SwapVertIcon height="24px" width="24px" color="textSubtle" />
          </IconButton> */}
          </Flex>
          <Box height={['80px', null, '80px']}
            background="#835818a8"
            borderRadius="12px"
            borderStyle="solid"
            borderWidth="1px"
            borderColor="#563708"
            padding="16px">
            {/* <Grid>
              {topFarms.map((topFarm, index) => (
                <TopFarmPool
                  // eslint-disable-next-line react/no-array-index-key
                  key={index}
                  title={topFarm?.lpSymbol}
                  percentage={topFarm?.apr + topFarm?.lpRewardsApr}
                  index={index}
                  visible={showFarms}
                />
              ))}
            </Grid> */}
            <Grid>
              {/* {topPools.map((topPool, index) => (
                <TopFarmPool
                  // eslint-disable-next-line react/no-array-index-key
                  key={index}
                  title="BIRB"
                  type="Manual restaking"
                  image="/images/custom/logo.png"
                  index={index}
                  visible={!showFarms}
                />
              ))} */}
              <TopFarmPool
                // eslint-disable-next-line react/no-array-index-key
                key="birb"
                title="BIRB"
                type="Manual restaking"
                image="/images/custom/logo.png"
                index={0}
                visible={!showFarms}
              />
            </Grid>
          </Box>
        </Flex>
      </div>
    </>
  )
}

export default FarmsPoolsRow
